import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as i0 from "@angular/core";
import * as i1 from "@ng-bootstrap/ng-bootstrap";
import * as i2 from "@fortawesome/angular-fontawesome";
import * as i3 from "@angular/common";
import * as i4 from "../../../ng-jhipster/language/jhi-translate.directive";
function ExternalVideoCallRedirectPopupComponent_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 7);
} }
function ExternalVideoCallRedirectPopupComponent_img_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 8);
} }
function ExternalVideoCallRedirectPopupComponent_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "h4", 12);
    i0.ɵɵtext(2, " Join Jitsi video call ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelementStart(5, "a", 14);
    i0.ɵɵtext(6, "Join from your browser");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("href", ctx_r4.webPlatformRedirectUrl, i0.ɵɵsanitizeUrl);
} }
function ExternalVideoCallRedirectPopupComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, ExternalVideoCallRedirectPopupComponent_div_6_div_1_Template, 7, 1, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.webPlatformRedirectUrl);
} }
function ExternalVideoCallRedirectPopupComponent_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "h4", 16);
    i0.ɵɵtext(2, " Don\u2019t have Zoom Client installed? ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelementStart(5, "a", 14);
    i0.ɵɵtext(6, "Join from your browser");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("href", ctx_r5.webPlatformRedirectUrl, i0.ɵɵsanitizeUrl);
} }
function ExternalVideoCallRedirectPopupComponent_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "h4", 18);
    i0.ɵɵtext(2, " Already have Zoom Client installed? ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelementStart(5, "a", 19);
    i0.ɵɵtext(6, "Launch meeting");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("href", ctx_r6.nativePlatformRedirectUrl, i0.ɵɵsanitizeUrl);
} }
function ExternalVideoCallRedirectPopupComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, ExternalVideoCallRedirectPopupComponent_div_7_div_1_Template, 7, 1, "div", 10);
    i0.ɵɵtemplate(2, ExternalVideoCallRedirectPopupComponent_div_7_div_2_Template, 7, 1, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.webPlatformRedirectUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.nativePlatformRedirectUrl);
} }
export class ExternalVideoCallRedirectPopupComponent {
    constructor(modelService) {
        this.modelService = modelService;
        // copyToClipboard(): void {
        //   this.copyTextToClipboard(this.landingLink);
        // }
        //
        // fallbackCopyTextToClipboard(text: string):void {
        //   let textArea = document.createElement("textarea");
        //   textArea.value = text;
        //
        //   // Avoid scrolling to bottom
        //   textArea.style.top = "0";
        //   textArea.style.left = "0";
        //   textArea.style.position = "fixed";
        //
        //   document.body.appendChild(textArea);
        //   textArea.focus();
        //   textArea.select();
        //
        //   try {
        //     const successful = document.execCommand('copy');
        //     if(successful) {
        //       this.onCopyToClipboardSuccess();
        //     }
        //   } catch (err) {
        //     console.error('Fallback: Oops, unable to copy', err);
        //   }
        //
        //   document.body.removeChild(textArea);
        // }
        // copyTextToClipboard(text: string):void {
        //   if (!navigator.clipboard) {
        //     this.fallbackCopyTextToClipboard(text);
        //     return;
        //   }
        //   let self = this.onCopyToClipboardSuccess;
        //   navigator.clipboard.writeText(text).then(()=> {
        //     self();
        //   }, (err) => {
        //     console.error('Async: Could not copy text: ', err);
        //   });
        // }
        //
        // onCopyToClipboardSuccess() : void {
        //   this.copied = true;
        // }
        this.close = close;
    }
    set redirectUrl(value) {
        this._redirectUrl = value;
        this.generateRedirectUrls();
    }
    get redirectUrl() {
        return this._redirectUrl;
    }
    set userId(value) {
        this._userId = value;
        this.generateRedirectUrls();
    }
    get userId() {
        return this._userId;
    }
    ngOnInit() {
    }
    generateRedirectUrls() {
        if (this.redirectUrl && this.userId) {
            this.externalVideoCallProvider = this.determineVideoCallProvider(this.redirectUrl);
            this.webPlatformRedirectUrl = `${this.redirectUrl}/${this.userId}?platform=WEB`;
            this.nativePlatformRedirectUrl = `${this.redirectUrl}/${this.userId}?platform=NATIVE`;
        }
    }
    determineVideoCallProvider(redirectUrl) {
        if (redirectUrl.endsWith('JITSI') || redirectUrl.indexOf('jitsi') > 0) {
            return 'JITSI';
        }
        else {
            return 'ZOOM';
        }
    }
    closePopUp() {
        this.modelService.dismissAll();
    }
}
ExternalVideoCallRedirectPopupComponent.ɵfac = function ExternalVideoCallRedirectPopupComponent_Factory(t) { return new (t || ExternalVideoCallRedirectPopupComponent)(i0.ɵɵdirectiveInject(i1.NgbModal)); };
ExternalVideoCallRedirectPopupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExternalVideoCallRedirectPopupComponent, selectors: [["external-video-call-redirect-popup"]], inputs: { redirectUrl: "redirectUrl", userId: "userId" }, decls: 8, vars: 4, consts: [[1, "olha-theme", "px-4", "pb-4"], [1, "d-flex", "justify-content-end"], ["icon", "times-circle", "tabindex", "-1", 1, "mt-3", 2, "cursor", "pointer", 3, "click"], [1, "text-center", "pb-3"], ["class", "zoom-video-icon", "src", "../../../../../content/images/zoom-icon.png", "width", "90", "alt", "talking.png", 4, "ngIf"], ["class", "jitsi-video-icon", "src", "../../../../../content/images/jitsi-icon.svg", "width", "70", "alt", "talking.png", 4, "ngIf"], ["class", "d-flex flex-column flex-lg-row justify-content-between p-2 text-center", 4, "ngIf"], ["src", "../../../../../content/images/zoom-icon.png", "width", "90", "alt", "talking.png", 1, "zoom-video-icon"], ["src", "../../../../../content/images/jitsi-icon.svg", "width", "70", "alt", "talking.png", 1, "jitsi-video-icon"], [1, "d-flex", "flex-column", "flex-lg-row", "justify-content-between", "p-2", "text-center"], ["class", "", "style", "flex: 1 1 0px;", 4, "ngIf"], [1, "", 2, "flex", "1 1 0px"], ["jhiTranslate", "sessionChat.paragraph.externalVideoCallRedirect.jitsiJoinFromBrowser"], [1, "d-flex", "mt-3", "justify-content-center"], ["tabindex", "0", "target", "_blank", "jhiTranslate", "sessionChat.button.externalVideoCallRedirect.joinFromBrowser", 1, "btn", "btn-primary", 3, "href"], ["class", "nativePlatformRedirectUrlContainer", "style", "flex: 1 1 0px;", 4, "ngIf"], ["jhiTranslate", "sessionChat.paragraph.externalVideoCallRedirect.zoomJoinFromBrowser"], [1, "nativePlatformRedirectUrlContainer", 2, "flex", "1 1 0px"], ["jhiTranslate", "sessionChat.paragraph.externalVideoCallRedirect.zoomJoinViaNativeApp"], ["target", "_blank", "jhiTranslate", "sessionChat.button.externalVideoCallRedirect.joinViaNativeApp", 1, "btn", "btn-primary", "btn-secondary", 3, "href"]], template: function ExternalVideoCallRedirectPopupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "fa-icon", 2);
        i0.ɵɵlistener("click", function ExternalVideoCallRedirectPopupComponent_Template_fa_icon_click_2_listener() { return ctx.closePopUp(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, ExternalVideoCallRedirectPopupComponent_img_4_Template, 1, 0, "img", 4);
        i0.ɵɵtemplate(5, ExternalVideoCallRedirectPopupComponent_img_5_Template, 1, 0, "img", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, ExternalVideoCallRedirectPopupComponent_div_6_Template, 2, 1, "div", 6);
        i0.ɵɵtemplate(7, ExternalVideoCallRedirectPopupComponent_div_7_Template, 3, 2, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.externalVideoCallProvider === "ZOOM");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.externalVideoCallProvider === "JITSI");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.externalVideoCallProvider == "JITSI");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.externalVideoCallProvider == "ZOOM");
    } }, directives: [i2.FaIconComponent, i3.NgIf, i4.JhiTranslateDirective], styles: [".nativePlatformRedirectUrlContainer[_ngcontent-%COMP%]{border-top:1px solid #cedbd7;border-left:0;margin-top:2rem;padding-top:2rem}@media(min-width: 992px){.nativePlatformRedirectUrlContainer[_ngcontent-%COMP%]{border-left:1px solid #cedbd7;border-top:0;margin-top:0;padding-top:0}}"] });
